import { Button } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { GetCustomerCartQuery } from '../../../graphql/magento'
import { cartTotal } from '../../../utils/priceTools'
import Link from '../../global/Link'
import CaliforniaProp65Warning from '../summary/CaliforniaProp65Warning'

export interface MiniCartModalHeaderProps {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  className?: string
  disableButtons: boolean
  handleEditCart(): void
}

const MiniCartModalHeader: React.FC<MiniCartModalHeaderProps> = ({
  cart,
  className,
  disableButtons,
  handleEditCart,
}) => (
  <header className={className}>
    <h4>Estimated total: {cartTotal({ cart })}</h4>
    <Button
      color="secondary"
      component={Link}
      disabled={disableButtons}
      onClick={handleEditCart}
      to="/checkout"
      variant="outlined"
    >
      EDIT CART
    </Button>
    <CaliforniaProp65Warning
      items={cart.items || []}
      shippingAddress={cart.shipping_addresses?.[0]}
    />
  </header>
)

const StyledMiniCartModalHeader = styled(MiniCartModalHeader)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  display: flex;
  flex-wrap: wrap;
  min-height: 90px;
  padding: 0 15px;
  justify-content: space-between;
  .MuiLink-underlineHover {
    text-decoration: none;
  }
  ${CaliforniaProp65Warning} {
    flex: 0 0 100%;
    a {
      color: ${({ theme }) => theme.colors.component.textDark};
    }
  }
`

export default StyledMiniCartModalHeader
